const values = [
  "English",
  "Chinese (Simplified)",
  "Spanish",
  "Portuguese",
  "Korean",
  "Japanese",
  "Chinese (Traditional)",
  "French",
  "German",
  "Russian",
  "Italian"
];
export default values;
